import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import AuthRoutes from "./AuthRoutes";
import Register from "../../containers/SignUp";
import Personalize from "../../containers/SignUp/personalize";
import SignIn from "../../containers/SignIn";
import ResetPassword from "../../containers/SignIn/restPassword";
import SetPassword from "../../containers/SignIn/setPassword";
// import { Row, Col } from "antd";
// import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import Not_found from "../../containers/SignUp/not_found";
// import RmxFooterImage from "../../assets/images/logo-sec1.png";
// import RmxFooter from "../../assets/images/footer.png";
import ExpiredLink from "../../containers/SignUp/expiredlink";
// import StoreDown from "../../containers/SignUp/storedown";
import RmxCompanyFooter from "../../components/rmxFooter";
import RmxCompanyHeader from "../../components/rmxHeader";
import RmxMainHeader from "../../components/rmxHeader/mainHeader";
import StoreDown from "../../containers/SignUp/storedown";

class Routes extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  componentDidMount() { }

  render() {
    const { storeName, storeLoader } = this.props;
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          {!storeName?.rmx_shipping_charge && !storeLoader ? (
            <React.Fragment>
              {/* <RmxMainHeader /> */}
              <Switch>
                <Route exact path="/storedown" component={StoreDown} />
                {/* <Route exact path="/register" component={Register} />
                <Route exact path="/profile" component={Personalize} />
                <Route exact path="/setpassword" component={SetPassword} />
                <Route exact path="/reset-password" component={ResetPassword} />
                <Route exact path="/signin" component={SignIn} />
                <Route exact path="/expired_link" component={ExpiredLink} /> */}
                <Route path="*" render={() => <Redirect to="/storedown" />} />
              </Switch>
            </React.Fragment>
          ) : (
            storeName?.rmx_shipping_charge &&
            !storeLoader && (
              <React.Fragment>
                <Switch>
                  {/* <Route exact path='/store_down' render={() => <div></div>}></Route> */}
                  <Route
                    path="*"
                    render={() => (
                      <RmxCompanyHeader storeName={this.props?.storeName} />
                    )}
                  ></Route>
                </Switch>
                <Switch></Switch>
                <Switch>
                  <Route path="/" component={AuthRoutes} />
                  <Route path="*" render={() => <AuthRoutes />}></Route>
                </Switch>
                <Switch>
                  <Route path="*" render={() => <RmxCompanyFooter />}></Route>
                </Switch>
              </React.Fragment>
            )
          )}
        </Switch>
      </Suspense>
    );
  }
}

export default connect((storeState) => {
  return {
    isAuthenticated: storeState.AuthReducer?.isAuthenticated,
    storeName: storeState.AuthReducer.storeInfo,
    storeLoader: storeState?.AuthReducer?.storeLoader,
  };
})(Routes);
